import React from 'react';
import { useState } from 'react';
import Axios from 'axios';
import Input from './inputbukadonasi'
import Upload from './uploadimage';
import './bukadonasi.css'
import Nav from '../Nav/nav';


const CreateOpenDonation = () => {
    const [donationName, setDonationName] = useState('');
    const [image, setImage] = useState('');
    const [description, setDescription] = useState('')
    const [donationNeeded, setDonationNeeded] = useState('')
    const [expiredDate, setExpiredDate] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [donationTypeId, setDonationTypeId] = useState('');
    // const [imagePreview, setImagePreview] = useState(null);

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('donationName:', donationName);
        console.log('description:', description);
        console.log('donationNeeded:', donationNeeded);
        console.log('expiredDate:', expiredDate);
        console.log('categoryId:', categoryId);
        console.log('donationTypeId:', donationTypeId);
        console.log('image:', image);

        const data = new FormData();
        data.append("image", image);
        data.append("donationName", donationName);
        data.append("description", description);
        data.append("donationNeeded", donationNeeded);
        data.append("expiredDate", expiredDate);
        data.append("categoryId", categoryId);
        data.append("donationTypeId", donationTypeId);

        const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjcsImVtYWlsIjoiYnVkeWhhcnRvbm81NUBnbWFpbC5jb20iLCJpYXQiOjE2MjY0NDYwMzV9.eTzWbjGxalaTf_4E23D49XhveuXIAj7RYv6jUGAqP0o"
        Axios.post('https://weshare-heroku.herokuapp.com/api/weShare/openDonation/create', data, {
            headers: {
                'content-type': 'multipart/form-data',
                Authorization: token
            }
        })
            .then(res => {
                console.log(res)
            })
            .catch(err => {
                console.log(err);
            })


    }


    const onImageUpload = (e) => {
        const file = e.target.files[0];
        setImage(file)
        // setImagePreview(URL.createObjectURL(file))
    }

    return (
        <>
            <Nav />
            <div className="create-open-donation">
                <form className="open-donation-card">
                    <div className="banner-open-donation">
                        <h1 className="banner-open-donation-txt">Buka Donasi</h1>
                    </div>
                    <div className="padding-form">
                        <label className="label-open-donation">Upload Foto Donasi<span className="star-red">*</span></label>
                        <Upload
                            type="file"
                            // img={imagePreview}
                            onChange={(e) => onImageUpload(e)}
                        />
                        <Input
                            label="Nama Donasi"
                            type="text"
                            value={donationName}
                            onChange={(e) => setDonationName(e.target.value)}
                        />
                        <label className="label-open-donation">Deskripsi<span className="star-red">*</span></label>
                        <textarea
                            className="text-area-od"
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        >
                        </textarea>
                        <Input
                            label="Donasi yang dibutuhkan"
                            type="text"
                            value={donationNeeded}
                            onChange={(e) => setDonationNeeded(e.target.value)}
                        />
                        <Input
                            label="Rentang Waktu"
                            type="text"
                            value={expiredDate}
                            onChange={(e) => setExpiredDate(e.target.value)}
                            placeholder="ex:2021-09-18"
                        />
                        <div className="open-donation-column">
                            <label className="label-open-donation">Kategori Donasi<span className="star-red">*</span></label>
                            <select
                                className="input-open-donation"
                                value={categoryId}
                                onChange={(e) => setCategoryId(e.target.value)}
                            >
                                <option value="Pilih Kategori Donasi">Pilih Kategori Donasi</option>
                                <option value="1">Kemanusiaan</option>
                                <option value="2">Pendidikan</option>
                                <option value="3">Kesehatan</option>
                                <option value="4">Anak</option>
                            </select>
                            <label className="label-open-donation">Jenis Donasi<span className="star-red">*</span></label>
                            <select
                                className="input-open-donation"
                                value={donationTypeId}
                                onChange={(e) => setDonationTypeId(e.target.value)}
                            >
                                <option value="Pilih Jenis Donasi">Pilih Jenis Donasi</option>
                                <option value="1">Makanan</option>
                                <option value="2">Uang</option>
                                <option value="3">Elektronik</option>
                                <option value="4">Buku</option>
                                <option value="5">Pakaian</option>
                                <option value="6">Mainan Anak</option>
                                <option value="7">Medis</option>
                            </select>
                            <button className="submit-buka-donasi" type="submit" onClick={onSubmit}>Buka Donasi</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default CreateOpenDonation;